<template>
  <v-layout row wrap class="mb-3">
    <v-flex xs12>
      <span class="dashed pointer pull-right my-2" @click="showPanel=!showPanel">{{showPanel?'Свернуть панель':'Добавить объект'}}</span>
    </v-flex>
    
    <v-flex xs12 v-show="showPanel">
      <v-alert v-model="errorPanel.show" dismissible :type="errorPanel.type" transition="fade-transition" outline>
        {{errorPanel.text}}
      </v-alert>
      
      <v-radio-group v-model="objectType" row>
        <v-radio label="Внутренний объект" :value="0"></v-radio>
        <v-radio label="Внешний объект" :value="1"></v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex xs12 sm6 v-show="showPanel && objectType===0" class="mb-2">
      <dantser-tree
        ref="beingTree"
        :checkbox="true"
        :selectMode="2"
        :source="treedata"
        :style="{height:'150px', overflow:'scroll', border:'1px solid #c5c5c5'}"
      ></dantser-tree>
    </v-flex>
    <v-flex xs12 sm6 v-show="showPanel && objectType===1">
      <v-text-field label="Название внешнего объекта" v-model="objectName"></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 class="pl-2 text-xs-left" v-show="showPanel">
      <v-btn color="secondary" @click="addNode()">Добавить</v-btn>
    </v-flex>
    
    <v-flex xs12>
      <v-data-table :headers="headers" :items="scopeList" item-key="identified" hide-actions no-data-text="Данные отсутствуют" ref="sortableTable">
        <template slot="items" slot-scope="props">
          <tr class="sortableRow text-xs-center" :key="props.item.identified" v-if="props.item.visible">
            <td class="pa-0 ma-0" style="width:10px">
              <v-icon class="sortHandle pointer">mdi-menu-swap</v-icon>
            </td>
            <td class="text-xs-left pl-1">
              <v-edit-dialog v-if="props.item.element_type==='outer'" @save="props.item.identified=props.item.name" :return-value.sync="props.item.name" large lazy cancel-text="Отмена" save-text="Сохранить">
                <div>{{ props.item.name }}</div>
                <div slot="input" class="mt-3 title">Редактировать название</div>
                <v-text-field
                  slot="input"
                  v-model="props.item.name"
                  label="Название"
                  autofocus
                  single-line
                  hide-details
                ></v-text-field>
              </v-edit-dialog>
              <span v-else>{{ props.item.name }}</span>
            </td>
            <td class="text-xs-center">{{ props.item.element_type==='outer' ? 'Внешний' : 'Внутренний' }}</td>
            <td class="text-xs-center pa-0 ma-0">
              <v-tooltip top>
                <v-btn slot="activator" class="red--text" icon flat @click="deleteObject(props.item)"><v-icon>close</v-icon></v-btn>
                <span>Удалить</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
      <span class="dashed pointer pull-right my-2 red--text" @click="showDeleted=!showDeleted">{{showDeleted?'Скрыть':'Показать'}} неактивные</span>
    </v-flex>
    
    <v-flex xs12 v-show="showDeleted">
      <v-data-table :headers="headers" :items="deleted_scopes" item-key="identified" hide-actions no-data-text="Данные отсутствуют">
        <template slot="items" slot-scope="props">
          <tr style="background: #f5f5f5"  v-if="props.item.visible">
            <td class="pa-0 ma-0" style="width:10px"></td>
            <td>{{ props.item.name }}</td>
            <td class="text-xs-center">{{ props.item.element_type==='outer' ? 'Внешний' : 'Внутренний' }}</td>
            <td class="text-xs-center pa-0 ma-0">
              <v-tooltip top>
                <v-btn slot="activator" class="green--text" icon flat @click="restoreObject(props.item)"><v-icon>mdi-backup-restore</v-icon></v-btn>
                <span>Восстановить</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
  const uuidv4 = require('uuid/v4')
  
  import Sortable from 'sortablejs'
  
  export default {
    name : "ObjectScope",
  
    props:{
      treedata: {
        type: Array,
        required: false,
        default: () => []
      },
      value: {
        type: Array,
        required: false,
        default: () => []
      },
      deleted_objects: {
        type: Array,
        required: false,
        default: () => []
      }
    },
  
    computed:{
      scopeList:{
        get(){
          return this.value
        },
        set(v){ }
      },
      deleted_scopes:{
        get(){
          return this.deleted_objects
        },
        set(v){ }
      }
    },
    
    data() {
      return {
        errorPanel: {
          show: false,
          type: 'error',
          text: ''
        },
        showPanel: false,
        showDeleted: false,
        headers: [
          { sortable: false, width: 10, class: 'ma-0 pa-0' },
          { text: 'Объект', align: 'left', sortable: false },
          { text: 'Тип', align: 'center', sortable: false, width: 60 },
          { text: 'Действия', align: 'center', sortable: false, width: 40 },
        ],
        objectType: 1,
        objectName: ''
      }
    },
    
    mounted(){
      new Sortable(
        this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        {
          draggable: '.sortableRow',
          handle: '.sortHandle',
          onEnd: this.dragObject
        }
      )
    },
  
    methods : {
      addNode(){
        if(this.objectType===0){
          let nodes = this.$refs['beingTree'].getNodesByProp('selected', true)
          if(nodes.length>0){
            nodes.map( node => {
              this.$refs['beingTree'].setSelected(node.id, false)
              if( this.scopeList.findIndex( el => el.identified === node.id) >= 0 ){
                this.errorPanel = { show: true, type: 'error', text: `Объект "${node.name}" уже существует` }
              } else if( this.deleted_scopes.findIndex( el => el.identified === node.id) >= 0 ){
                this.errorPanel = { show: true, type: 'info', text: `Объект "${node.name}" был удален, восстановите его` }
              } else {
                let obj = {
                  id: uuidv4(),
                  element_type: node.element_type,
                  identified: node.id,
                  name: node.name,
                  visible: true,
                }
                this.scopeList.push(obj)
                this.$emit('addObject', obj)
                if(node.element_type==='container'){
                  node.children.map( child => {
                    if(child.element_type==='post'){
                      let post = {
                        id: uuidv4(),
                        element_type: child.element_type,
                        identified: child.id,
                        name: child.name,
                        visible: false,
                      }
                      this.scopeList.push(post)
                      this.$emit('addObject', post)
                    }
                  })
                }
              }
            })
            this.$emit('input', this.scopeList)
          }
        } else if(this.objectType===1){
          if( this.scopeList.findIndex( el => el.identified === this.objectName) >= 0 ){
            this.errorPanel = { show: true, type: 'error', text: `Объект "${this.objectName}" уже существует` }
          } else if( this.deleted_scopes.findIndex( el => el.identified === this.objectName) >= 0 ) {
            this.errorPanel = { show: true, type: 'info', text: `Объект "${this.objectName}" был удален, восстановите его` }
          } else {
            let inner = {
              id: uuidv4(),
              element_type: 'outer',
              identified: this.objectName,
              name: this.objectName,
              visible: true,
            }
            this.scopeList.push(inner)
            this.$emit('input', this.scopeList)
            this.$emit('addObject', inner)
          }
        }
        // Очистить переменные после добавления
        this.objectName = ''
      },
    
      deleteObject(item){
        const index = this.scopeList.findIndex( el => {
          return el.id === item.id && el.identified === item.identified
        })
        if(index >= 0){
          let obj = this.scopeList.splice(index, 1)
          this.$emit('deleteObj', obj[0])
          
          this.deleted_scopes.push(obj[0])
          if(obj[0].element_type==='container'){
            let container = this.$refs['beingTree'].getNodeById(obj[0].identified)
            if(container != null){
              container.children.map(item=>{
                if(item.element_type==='post'){
                  let postIndex = this.scopeList.findIndex( el => (el.identified === item.id && el.element_type === "post" && el.visible===false))
                  if(postIndex>=0){
                    let post = this.scopeList.splice(postIndex, 1)
                    this.deleted_scopes.push(post[0])
                    this.$emit('deleteObj', post[0])
                  }
                }
              })
            }
          }
          this.$emit('input', this.scopeList)
        }
      },
      
      restoreObject(item){
        const index = this.deleted_scopes.findIndex( el => {
          return el.id === item.id && el.identified === item.identified
        })
        if(index >= 0){
          let restored = []
          let obj = this.deleted_scopes.splice(index, 1)
          this.scopeList.push(obj[0])
          restored.push(obj[0])
          if(obj[0].element_type==='container'){
            let container = this.$refs['beingTree'].getNodeById(obj[0].identified)
            if(container != null){
              container.children.map(item=>{
                if(item.element_type==='post'){
                  let postIndex = this.deleted_scopes.findIndex( el => (el.identified === item.id && el.element_type === "post" && el.visible===false))
                  if(postIndex>=0){
                    let post = this.deleted_scopes.splice(postIndex, 1)
                    this.scopeList.push(post[0])
                    restored.push(post[0])
                  }
                }
              })
            }
          }
          this.$emit('restoreObjects', restored)
          this.$emit('input', this.scopeList)
        }
      },
  
      dragObject ({oldIndex, newIndex}) {
        const movedItem = this.scopeList.splice(oldIndex, 1)[0]
        this.scopeList.splice(newIndex, 0, movedItem)
        this.$emit('input', this.scopeList)
      },
    },
    
    watch:{
      errorPanel(v){
        if(v.show){
          setTimeout( _ => {
            v.show = false
          }, 2500)
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Common/ObjectScope.vue